"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_USER_AGENT = void 0;
exports.TEST_USER_AGENT = "FluxCypressBot";
//# sourceMappingURL=testing.js.map